export const contentLoaded = ref( false )
export const menuOpen = ref( false )